const PERMISSIONS_ENUM = {
  DASHBOARD_VIEW: "dashboard_view",
  TASKS_VIEW: "tasks_view",
  PROJECT_VIEW: "project_view",
  PROJECT_EDIT: "project_edit",
  PROJECT_STATUS_CHANGE: "project_status_change",
  MEDIA_UPLOAD: "media_upload",
  DAMAGE_VIEW: "damage_view",
  ANNOTATION_EDIT: "annotation_edit",
  DAMAGE_EDIT: "damage_edit",
  REPORT_VIEW: "report_view",
  REPORT_EDIT: "report_edit",
  REPORT_GENERATION: "report_generation",
  REPORT_PUBLISH: "report_publish",
  DATA_EXPORT: "data_export",
  FINANCIAL_OVERVIEW: "financial_overview",
  TENDER_VIEW: "tender_view",
  TENDER_EDIT: "tender_edit",
  TENDER_APPROVE: "tender_approve",
  TENDER_PUBLISH: "tender_publish",
  MARKETPLACE_VIEW: "marketplace_view",
  MARKETPLACE_ACCEPT: "marketplace_accept",
  ASSIGNED_TASK_VIEW: "assigned_task_view",
  TASK_STATUS_UPDATE: "task_status_update",
  USER_VIEW: "user_view",
  USER_EDIT: "user_edit",
  SUB_USER_MANAGEMENT: "sub_user_management",
  ADMIN_ASSIGNMENT: "admin_assignment",
  SYSTEM_CONFIGURATION: "system_configuration",
  AUDIT_LOG_VIEW: "audit_log_view",
};

export default PERMISSIONS_ENUM;
